import { render } from "./SurveyMessage.vue?vue&type=template&id=0c31115f"
import script from "./SurveyMessage.vue?vue&type=script&lang=js"
export * from "./SurveyMessage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/survey-cms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__